// @ts-nocheck
import * as React from "react";

const RedChevron: React.FC = () => {
    return (
        <svg width="1152" height="40" viewBox="0 0 1152 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M139.5 0H325.5V40H116L139.5 0Z" fill="#CC0E33" />
            <path d="M252 0H1152V40H252V0Z" fill="#CC0E33" />
            <path d="M86.5 0H134L110 40H62L86.5 0Z" fill="#CC0E33" />
            <path d="M54.5 0L81 1.48625e-06L56.6667 40H30L54.5 0Z" fill="#CC0E33" />
            <path d="M35.5 0L49 1.48625e-06L25 40H11L35.5 0Z" fill="#CC0E33" />
            <path d="M23.5 0L30 1.48625e-06L6 40H0.5L23.5 0Z" fill="#CC0E33" />
        </svg>
    );
};

export default React.memo(RedChevron);
